import { Component, Input, OnInit } from '@angular/core';
import { faCheckCircle, faExclamationTriangle } from '@fortawesome/pro-duotone-svg-icons';

@Component({
   selector: 'samweb-system-monitor-status-icon',
   templateUrl: './system-monitor-status-icon.component.html',
   styleUrls: ['./system-monitor-status-icon.component.scss'],
})
export class SystemMonitorStatusIconComponent implements OnInit {
   public healthyIcon = faCheckCircle;
   public errorIcon = faExclamationTriangle;

   @Input()
   public isStatusOk: boolean;

   constructor() {}

   ngOnInit(): void {}
}
